/** Replace proxy URLs in image markdown with stored paths (compliance-docs/...) */
export function replaceProxyUrlsWithPaths(markdown: string): string {
  return markdown.replace(
    /!\[([^\]]*)\]\([^)]*\/machinery-directive-compliance\/[^/]+\/images\/(compliance-docs\/[^)]+)\)/g,
    '![$1]($2)'
  )
}

/** Replace stored paths with proxy URLs so images display when loading from stored markdown */
export function replacePathsWithProxyUrls(
  markdown: string,
  getProxyUrl: (path: string) => string
): string {
  return markdown.replace(
    /!\[([^\]]*)\]\((compliance-docs\/[^)]+)\)/g,
    (_, alt, path) => `![${alt}](${getProxyUrl(path)})`
  )
}
